import checkForHolidayDecorations from "./check_for_holiday_decorations";

export const determineBackgroundURL = (backgroundType, currentGameDate, conditionsTable,
        cardImage, pictureInfo ) => {
        let backgroundName = "";
        let holidayObj = {};
        let holidayDecoration = false;
        let backgroundURL = "";
        const funStuffCheckArr = backgroundType.split("-");
        let funStuffBackground = false;
        if (funStuffCheckArr[0] === "funStuff"){
            funStuffBackground = true;
        }
        switch (backgroundType) {
            case "home":
                backgroundName = "livingRoomImg";
                const checkHolidayObj = checkForHolidayDecorations(currentGameDate, conditionsTable);
                holidayDecoration = checkHolidayObj.holidayDecoration;
                holidayObj = checkHolidayObj.holidayObj;
                break;
            case "work":
                backgroundName = "jobBackground";
                cardImage = false;
                break;
            default:
                backgroundName = backgroundType;
                break;
        }
        // the following sets the value of backgroundURL to the variableName label in the pictureInfo
        if (funStuffBackground === true){
            backgroundURL = pictureInfo.funStuffInfo[backgroundName];
        }else{
            backgroundURL = pictureInfo[backgroundName];
        }
        const returnObj = {holidayDecoration: holidayDecoration, holidayObj: holidayObj,
            backgroundURL: backgroundURL, cardImage: cardImage }
        return returnObj;
}
export default determineBackgroundURL;